import { render, staticRenderFns } from "./BtnIssueInvoice.yaml?vue&type=template&id=7904e703&component"
import script from "./BtnIssueInvoice.yaml?vue&type=script&lang=ts&component"
export * from "./BtnIssueInvoice.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports